<div class="flex flex-col p-10 bg-neutrals-0 rounded-3xl w-full">
  <div class="flex flex-col gap-12 items-center w-full">
    <div class="flex flex-col gap-6 items-center w-full text-center">
      <ui-illustrative-icon name="i-warning" size="m"></ui-illustrative-icon>
      <ui-headline
        type="h20"
        text-color="neutrals-900"
        font-weight="semibold"
        [content]="title"
      ></ui-headline>
      <div
        *ngIf="detailSegments?.length; else plainDetail"
        class="flex flex-col gap-4 text-neutrals-700 text-base leading-normal text-center"
      >
        <p *ngFor="let paragraph of detailSegments">
          <span
            *ngFor="let seg of paragraph"
            [class.font-semibold]="seg.bold"
            >{{ seg.text }}</span
          >
        </p>
      </div>
      <ng-template #plainDetail>
        <div class="flex flex-col gap-4 text-neutrals-700 text-center">
          <ui-paragraph
            type="p16"
            text-color="neutrals-700"
            [content]="detail"
          ></ui-paragraph>
          <ui-paragraph
            *ngIf="detail2"
            type="p16"
            text-color="neutrals-700"
            [content]="detail2"
          ></ui-paragraph>
        </div>
      </ng-template>
    </div>
    <div class="flex flex-col gap-2 w-full">
      <ui-button
        type="primary"
        responsive="false"
        size="lg"
        [attr.button-text]="acceptLabel"
        [enabled]="true"
        [isLoading]="isLoading"
        (clicked)="onAcceptClick()"
      ></ui-button>
      <ui-button
        type="secondary"
        responsive="false"
        size="lg"
        button-text="Ahora no"
        [enabled]="true"
        [isLoading]="false"
        (clicked)="onCancel()"
      ></ui-button>
    </div>
  </div>
</div>
